<script setup lang="ts">
import { getArticleList } from "@carnet/api/backoffice";

const { t } = useI18n();
const { openModal: openCookieConsentModal } = useCookieConsent();
const nuxtApp = useNuxtApp();
const cachedData = { getCachedData: (key: string) => nuxtApp.payload.data[key] ?? nuxtApp.static.data[key] };

const localePath = useLocalePath();

// L'API CMS peut renvoyer autre chose qu'un tableau (spec divergente) : on borne au tableau
// pour ne pas casser le `.map` du footer présent sur toutes les pages.
const fetchList = (context: string) =>
  getArticleList({ composable: "$fetch", path: { locale: appLocale() }, query: { context } }).then((r) =>
    Array.isArray(r) ? r : []
  );

const { data: linksData } = await useAsyncData("footer-links", () => fetchList("footerLinks"), cachedData);

const links = computed(() =>
  (linksData.value ?? []).map((a) => {
    const external = /^https?:\/\//i.test(a.link);
    // Liens internes (ex. « /cgu ») : on préfixe la locale (stratégie i18n `prefix`) sinon la
    // route nue ne matche pas. Les liens externes (https://) restent tels quels.
    return { label: a.title, url: external ? a.link : localePath(a.link), external };
  })
);
</script>

<template>
  <footer class="relative z-1 bg-secondary text-primary px-6 sm:px-10 pt-2 pb-safe-or-2">
    <ul class="flex flex-wrap gap-x-6 gap-y-1 sm:gap-x-8">
      <li v-for="link in links" :key="link.label">
        <UButton
          :to="link.url"
          variant="link"
          class="inline-flex items-center gap-1 text-sm no-underline font-normal"
          :trailing-icon="link.external ? 'icon:external' : undefined"
          :target="link.external ? '_blank' : undefined"
          :rel="link.external ? 'noopener noreferrer' : undefined"
        >
          {{ link.label }}
        </UButton>
      </li>
      <li>
        <UButton variant="link" class="inline-flex items-center gap-1 text-sm no-underline font-normal" @click="openCookieConsentModal">
          {{ t("cookies.manage") }}
        </UButton>
      </li>
    </ul>
  </footer>
</template>
